import angular from "angular";
import { RecordDataSource } from "../../../records/grids";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { LookupFilter } from "../../../records/grids/columns/filters/subFilters/LookupFilter";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  vsName as DoubleClickHandlerServiceName,
  DoubleClickHandlerService,
} from "../../../records/grids/cells";

import { Record } from "../../../records/server/crud";
import { ColDef } from "../../../records/grids/columns/colDef";
import { ProgressivePermissions } from "../../permissions";

const gridId = Symbol("progressiveControllerGridSettings");
const progressiveControllerTypeUrl =
  "/api/machines/progressives/ProgressiveControllerType";

export class ProgressiveControllerTypeViewController {
  static $inject = [
    GridSettingsServiceName,
    "$compile",
    ServerUtilityName,
    DoubleClickHandlerServiceName,
  ];

  gridDataSource: RecordDataSource;
  gridSettings: IGridSettings;
  columns: ColDef[];

  constructor(
    gridSettingsService: GridSettingsService,
    $compile: angular.ICompileService,
    serverUtility: ServerUtility,
    doubleClickHandlerService: DoubleClickHandlerService
  ) {
    this.gridDataSource = new RecordDataSource(
      serverUtility,
      progressiveControllerTypeUrl,
      true
    );
    this.gridSettings = gridSettingsService.getGridSettings(gridId);
    this.columns = [
      {
        field: "Id",
        hide: true,
        headerName: "Id",
        filter: new FilterProvider("Id", $compile)
          .defaultNumberFilters()
          .getGridFilterFactory(),
      },
      {
        field: "Name",
        headerName: "Name",
        filter: new FilterProvider("Name", $compile)
          .defaultStringFilters()
          .addFilter(
            "=",
            new LookupFilter({
              displayName: "=",
              queryFieldNames: ["Id"],
              serverQuery: (search: string) =>
                serverUtility.lookupQueryWrapped({
                  url: progressiveControllerTypeUrl,
                  search,
                }),
            })
          )
          .getGridFilterFactory(),
        cellDoubleClicked: doubleClickHandlerService.patchDoubleClickHandler({
          requiresPermission: ProgressivePermissions.EditPermission,
          patchField: {
            formField: {
              key: "Name",
              name: "Name",
              type: "gridInput",
              templateOptions: {
                label: "Name",
                required: true,
              },
              modelOptions: {
                debounce: 500,
              },
              asyncValidators: {
                unique: ($viewValue, $modelValue, $scope) => {
                  const id = $scope.model?.Id;
                  return serverUtility
                    .alreadyExistsWrapped({
                      url: progressiveControllerTypeUrl,
                      query: {
                        Name: $viewValue,
                      },
                      excludeId: id,
                    })
                    .then((alreadyExists) => {
                      if (alreadyExists) {
                        throw new Error();
                      }
                    });
                },
              },
            },
          },
          submit: (patchObject) => {
            return serverUtility.patch({
              url: progressiveControllerTypeUrl,
              patchObject,
            });
          },
          fetchRecord: (args) =>
            serverUtility.querySingleWrapped<Record>({
              url: progressiveControllerTypeUrl,
              query: {
                Id: args.data.Id,
              },
            }),
        }),
      },
    ];
  }
}
